import React from "react";
import { Card, Row } from "antd";
import { BaseComponent } from "../../../base/BaseComponent";
import ContactUsComponent from "../../../contact-us/ContactUs";
import BlogsCard from "../../../shared/BlogsCard/BlogsCard";
import AdvisoryCard from "./AdvisoryCard/AdvisoryCard";
import "./BlockchainAdvisory.less";
import HowToBCA from "../HowToBCA/HowToBCA";
import FrontBanner from "./FrontBanner/FrontBanner";

export default class BlockchainAdvisory extends BaseComponent {
  render() {
    return (
      <>
        <FrontBanner />
        <div className="gx-mb-5">
          <h1 className="gx-text-center heading-big gx-mb-4">
            Why you should choose us?
          </h1>
          <hr className="heading-bottom-line gx-text-center" />
          <ul
            className="list-medium gx-text-center"
            style={{ listStyle: "none" }}
          >
            <li>1. Effective Communication</li>
            <li>2. Cutting-edge Solutions</li>
            <li>3. Absolute Transparency </li>
            <li>4. Reliable Security</li>
            <li>5. Reduced Costs</li>
          </ul>
        </div>

        <div className="gx-mb-5">
          <h1 className="gx-text-center heading-big gx-mb-4">
            {this.lang.Blockchain} {this.lang.Services}
          </h1>
          <hr className="heading-bottom-line gx-text-center" />

          <Row className="bca-row gx-text-center">
            {this.antd.colmd6(
              <Card className="gx-card bca-card">
                <img src="/assets/images/research.svg" alt="Secured" />
                <h1 className="heading-medium">
                  {this.lang.Technical} {this.lang.Analysis}
                </h1>
                <p className="text-small">{this.lang.TechnicalAnalysisPara}</p>
              </Card>
            )}

            {this.antd.colmd6(
              <Card className="gx-card bca-card">
                <img src="/assets/images/contract.svg" alt="DDOS Protection" />
                <h1 className="heading-medium">
                  {this.lang.TermsAndConditions}
                </h1>
                <p className="text-small">{this.lang.TermsAndConditionsPara}</p>
              </Card>
            )}

            {this.antd.colmd6(
              <Card className="gx-card bca-card">
                <img src="/assets/images/customer.svg" alt="Offline Storage" />
                <h1 className="heading-medium">{this.lang.KYC}</h1>
                <p className="text-small">{this.lang.KYCPara}</p>
              </Card>
            )}
            {this.antd.colmd6(
              <Card className="gx-card bca-card">
                <img src="/assets/images/network.svg" alt="Offline Storage" />
                <h1 className="heading-medium">{this.lang.Networking}</h1>
                <p className="text-small">{this.lang.NetworkingPara}</p>
              </Card>
            )}
          </Row>
        </div>
        <AdvisoryCard />
        <HowToBCA />
        <BlogsCard />
        <ContactUsComponent {...this.props} />
      </>
    );
  }
}
